
namespace Matrix.Workflow {

    export class WorkflowQueueGridOptions {
        queueCode: string;
        queueName: string;
        statusCodes: string[];
        columns: Serenity.PropertyItem[];
        formFields: Serenity.PropertyItem[];
    }

    @Serenity.Decorators.registerClass()
    export class WorkflowQueueGrid extends SiteEntityGrid<WorkflowInstanceRow, WorkflowQueueGridOptions> {
        protected getColumnsKey() { return 'Workflow.WorkflowInstance'; }
        protected getDialogType() { return WorkflowQueueItemDialog; }
        protected getIdProperty() { return WorkflowInstanceRow.idProperty; }
        protected getLocalTextPrefix() { return WorkflowInstanceRow.localTextPrefix; }
        protected getService() { return WorkflowInstanceService.baseUrl; }

        constructor(container: JQuery, opt: WorkflowQueueGridOptions) {
            super(container, opt);
        }

        protected getDialogOptionsFor(entityType: string): any {
            return {
                queueCode: this.options.queueCode,
                queueName: this.options.queueName,
                formFields: this.options.formFields
            }
        }

        protected getInitialTitle() {
            return this.options.queueName;
        }

        protected getButtons() {
            return super.getButtons().filter(x => x.cssClass != "add-button");
        }

        protected onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            var req = this.view.params as WorkflowInstanceListRequest;
            req.QueueCode = this.options.queueCode;
            req.Criteria = Serenity.Criteria.and(req.Criteria,
                [Serenity.Criteria.Operator.isNull, [WorkflowInstanceRow.Fields.CurrentAction]]);

            return true;
        }

        protected getPropertyItems() {
            return (this.options.columns && this.options.columns.length) ?
                this.options.columns : Q.getColumns("Workflow.WorkflowInstance");
        }

        protected gridPersistanceFlags() {
            var flags = super.gridPersistanceFlags();
            flags.quickFilters = false;
            return flags;
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            if (Q.indexOf(filters, x => x.field == WorkflowInstanceRow.Fields.StatusCode) < 0) {
                filters.splice(0, 0, {
                    field: 'StatusCode',
                    title: 'Status Code',
                    type: Serenity.LookupEditor,
                    init: (w: Serenity.LookupEditor) => {
                        w.values = this.options.statusCodes == null ? ['PENDING'] : this.options.statusCodes
                    },
                    options: {
                        lookupKey: WorkflowStatusRow.lookupKey,
                        multiple: true
                    }
                });
            }

            return filters;
        }
    }
}